const sidenav = {
  abandonedCallsBadge: 'MainLayout-Sidenav-AbandonedCallsBadge',
} as const;

export const mainLayoutLocators = {
  sidenav,
} as const;
